import { render, staticRenderFns } from "./AnswerRulesTable.vue?vue&type=template&id=24e55377&scoped=true"
import script from "./AnswerRulesTable.vue?vue&type=script&lang=js"
export * from "./AnswerRulesTable.vue?vue&type=script&lang=js"
import style0 from "./AnswerRulesTable.vue?vue&type=style&index=0&id=24e55377&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e55377",
  null
  
)

export default component.exports